var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating"},[_vm._m(0),_c('div',{staticClass:"stars-outer"},[_c('div',{staticClass:"stars-inner",style:({ width: _vm.starWidth })})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"float":"left","padding-right":"10px"}},[_c('img',{attrs:{"width":"30px","src":require("@/assets/images/turkish-restaurant-icon.png")}})])
}]

export { render, staticRenderFns }